/**
 * Created by Abner Sui on 12/15/2020
 * -------------------------------------
 */

import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { UtilsService } from '../../tamalelibs/services/utils.service';
import { BriefConfig } from '../../widgets/widgets.model';
import { Template } from './template-configuration.model';

@Component({
    selector: 'section-shell',
    templateUrl: './section-shell.component.html',
    styleUrls: ['./section-shell.component.scss']
})
export class SectionShellComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input()
    config: Template;
    @Input()
    ableMoveUp: boolean;
    @Input()
    ableMoveDown: boolean;
    @Input()
    ableMoveLeft: boolean;
    @Input()
    ableMoveRight: boolean;
    @Input()
    selectedControl;
    @Input()
    invalidControlId: Array<string>;
    @Input()
    options: BriefConfig;

    @Output()
    movedown: EventEmitter<any> = new EventEmitter();
    @Output()
    moveleft: EventEmitter<any> = new EventEmitter();
    @Output()
    moveright: EventEmitter<any> = new EventEmitter();
    @Output()
    moveup: EventEmitter<any> = new EventEmitter();
    @Output()
    movedownoutchild: EventEmitter<any> = new EventEmitter();
    @Output()
    moveupoutchild: EventEmitter<any> = new EventEmitter();
    @Output()
    selectChange: EventEmitter<any> = new EventEmitter();
    @Output()
    delete: EventEmitter<any> = new EventEmitter();
    @Output()
    deleteControl: EventEmitter<any> = new EventEmitter();
    /**
     * This event would be emitted each time the order of controls in current template is changed.
     *
     * @type {EventEmitter<any>}
     * @memberof SectionShellComponent
     */
    @Output()
    controlOrderChanged: EventEmitter<any> = new EventEmitter();

    @ViewChild('componentContainer', { static: false, read: ViewContainerRef }) componentContainer: ViewContainerRef;

    constructor(
        private _utils: UtilsService,
        private _changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
    }

    childWidthChange(event, i: number, j: number): void {
        let emptyWidth = 100;
        this.config.contains[i].forEach(item => emptyWidth = emptyWidth - item.width);
        this.config.contains[i].forEach(item => item.maxWidth = item.width + emptyWidth);
    }

    moveDown(event): void {
        if (this.ableMoveDown) {
            this.movedown.emit(this.config);
            this.controlOrderChanged.emit();
            this._utils.emptyClick(event);
        }
    }

    moveDownChild(event: Template, i: number, j: number): void {
        this.config.contains[i].splice(j, 1);
        const len = this.config.contains[i].length;
        if (len === 0) {
            this.config.contains.splice(i, 1);
        } else {
            if (len === 1) {
                this.config.contains[i][0].width = 100;
            } else if (len === 2) {
                this.config.contains[i][0].width = 50;
                this.config.contains[i][1].width = 50;
            }
            this.childWidthChange(event, i, j);
        }
        event.width = 100;
        event.maxWidth = 100;
        this.config.contains.splice(i + 1, 0, [event]);
        this.controlOrderChanged.emit();
        this._changeDetectorRef.detectChanges();
    }

    moveDownGrandChild(event, i, j): void {
        console.log('down grand child');
    }

    moveLeft(event): void {
        if (this.ableMoveLeft) {
            this.moveleft.emit(this.config);
            this.controlOrderChanged.emit();
            this._utils.emptyClick(event);
        }
    }

    moveLeftChild(event: Template, i: number, j: number): void {
        const temp = this.config.contains[i][j];
        this.config.contains[i][j] = this.config.contains[i][j - 1];
        this.config.contains[i][j - 1] = temp;
        this.controlOrderChanged.emit();
    }

    moveRight(event): void {
        if (this.ableMoveRight) {
            this.moveright.emit(this.config);
            this.controlOrderChanged.emit();
            this._utils.emptyClick(event);
        }
    }

    moveRightChild(event: Template, i: number, j: number): void {
        const temp = this.config.contains[i][j];
        this.config.contains[i][j] = this.config.contains[i][j + 1];
        this.config.contains[i][j + 1] = temp;
        this.controlOrderChanged.emit();
    }

    moveUp(event): void {
        if (this.ableMoveUp) {
            this.moveup.emit(this.config);
            this.controlOrderChanged.emit();
            this._utils.emptyClick(event);
        }
    }

    moveUpChild(event: Template, i: number, j: number): void {
        this.config.contains[i].splice(j, 1);
        const len = this.config.contains[i].length;
        if (len === 0) {
            this.config.contains.splice(i, 1);
            if (i === 0) {
                this.moveupoutchild.emit(event);
            } else {
                const targetLine: Array<any> = this.config.contains[i - 1];
                if (event.type !== 'section' && !event.fixWidth && targetLine.length === 1 && targetLine[0].type !== 'section' && !targetLine[0].fixWidth) {
                    targetLine[0].width = 50;
                    event.width = 50;
                    targetLine.push(event);
                    this.childWidthChange(event, i - 1, targetLine.length - 1);
                } else if (event.type !== 'section' && !event.fixWidth && (targetLine.length === 2 || targetLine.length === 3)) {
                    targetLine.forEach(item => item.width = 25);
                    event.width = 25;
                    targetLine.push(event);
                    this.childWidthChange(event, i - 1, targetLine.length - 1);
                } else {
                    event.width = 100;
                    event.maxWidth = 100;
                    this.config.contains.splice(i - 1, 0, [event]);
                }
            }
        } else {
            if (len === 1) {
                this.config.contains[i][0].width = 100;
            } else if (len === 2) {
                this.config.contains[i][0].width = 50;
                this.config.contains[i][1].width = 50;
            }
            this.childWidthChange(event, i, j);
            event.width = 100;
            event.maxWidth = 100;
            this.config.contains.splice(i, 0, [event]);
        }
        this.controlOrderChanged.emit();
        this._changeDetectorRef.detectChanges();
    }

    moveUpGrandChild(event, i, j): void {
        console.log('up grand child');
    }

    onDeleteSelf(event) {
        this.delete.emit(this.config);
        this._utils.emptyClick(event);
    }

    onDeleteChild(event, i, j) {
        const control: Template = this.config.contains[i].splice(j, 1)[0];
        if (this.config.contains[i].length === 0) {
            this.config.contains.splice(i, 1);
        }
        if (this.selectedControl && this.selectedControl.id === event.id) {
            this.onSelectChange(null);
        }
        this.deleteControl.emit(control);
    }

    onDeleteControl(event) {
        this.deleteControl.emit(event);
    }

    onSelectSelf(event): void {
        this.selectChange.emit(this.config);
        this._utils.emptyClick(event);
    }

    onSelectControl(event, i, j): void {
        this.selectChange.emit(this.config.contains[i][j]);
        this._utils.emptyClick(event);
    }

    onSelectChange(event): void {
        this.selectChange.emit(event);
    }

}
